import { environment } from "src/environments/environment.ipt.local";

/**
 *
 * NOMBRES DE RUTAS PARA MODULOS
 *
 * **/
// export const SLUG_LOGIN = "login";
export const SLUG_LOW_FLOW = "flujo";

/**
 * REDIRECCIONES
 */
export const PATH_REDIRECT_TO = `/`;
export const PATH_HOME = '/';
// export const PATH_ROUTE_LOGIN = `/${SLUG_LOGIN}`;

/**
 * RUTAS PARA AZURE
 */
export const AZURE_URI_REDIRECT_TO = `${environment.urlClientApp}`;
export const AZURE_URI_POST_LOGOUT_REDIRECT_TO= `${environment.urlPortalOrigin}/login`;
